import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, api, useTheme } from '../App';
import { Logo } from '../components/Logo';

export default function Login() {
  const [mode,       setMode]       = useState('login');
  const [email,      setEmail]      = useState('');
  const [password,   setPassword]   = useState('');
  const [name,       setName]       = useState('');
  const [inviteCode,   setInviteCode]   = useState('');
  const [dsgvoChecked, setDsgvoChecked] = useState(false);
  const [error,        setError]        = useState('');
  const [success,      setSuccess]      = useState('');
  const [loading,      setLoading]      = useState(false);
  const { login } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate  = useNavigate();
  const isDark = theme === 'dark';

  useEffect(() => {
    const msg = sessionStorage.getItem('ct_session_msg');
    if (msg) { setError(msg); sessionStorage.removeItem('ct_session_msg'); }
  }, []);

  async function handleSubmit(e) {
    e.preventDefault(); setError(''); setSuccess(''); setLoading(true);
    try {
      if (mode === 'forgot') {
        const data = await api('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) });
        setSuccess(data.message);
        return;
      }
      const path = mode === 'login' ? '/auth/login' : '/auth/register';
      const body = mode === 'login' ? { email, password } : { email, password, name, invite_code: inviteCode };
      const data = await api(path, { method: 'POST', body: JSON.stringify(body) });
      login(data.token, data.user); navigate('/');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative' }}>

      {/* Ambient blobs */}
      <div style={{ position: 'fixed', top: '5%', left: '10%', width: 500, height: 500, borderRadius: '50%', pointerEvents: 'none', background: 'radial-gradient(circle, rgba(0,100,200,0.18) 0%, transparent 65%)', filter: 'blur(60px)' }} />
      <div style={{ position: 'fixed', bottom: '8%', right: '8%', width: 400, height: 400, borderRadius: '50%', pointerEvents: 'none', background: 'radial-gradient(circle, rgba(0,200,255,0.1) 0%, transparent 65%)', filter: 'blur(50px)' }} />

      {/* Theme toggle */}
      <button onClick={toggleTheme} style={{ position: 'fixed', top: 20, right: 20, zIndex: 10, background: 'var(--glass)', border: '1px solid var(--glass-border2)', borderRadius: 20, padding: '6px 14px', fontSize: 12, fontFamily: 'Outfit', color: 'var(--text2)', cursor: 'pointer', backdropFilter: 'blur(12px)' }}>
        {isDark ? '☀ Light' : '🌙 Dark'}
      </button>

      <div className="fade-up" style={{ width: '100%', maxWidth: 420, position: 'relative', zIndex: 1 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <Logo size="lg" />
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>Posts in deiner Stimme — nicht in der von KI.</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span className="dot-live" style={{ width: 5, height: 5 }} />
            <span style={{ fontSize: 9, color: 'var(--green)', fontFamily: 'Outfit', letterSpacing: '0.1em' }}>SYSTEM ONLINE</span>
          </div>
        </div>

        {/* Card */}
        <div className="glass-intense" style={{ padding: 28, borderRadius: 20 }}>
          {/* Tabs */}
          {mode !== 'forgot' && (
            <div style={{ display: 'flex', gap: 3, background: isDark ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.05)', borderRadius: 12, padding: 3, marginBottom: 24, border: '1px solid var(--glass-border)' }}>
              {['login', 'register'].map(m => (
                <button key={m} onClick={() => { setMode(m); setError(''); setSuccess(''); }} style={{
                  flex: 1, padding: '8px', borderRadius: 10, fontFamily: 'Outfit', fontSize: 13, fontWeight: 600, cursor: 'pointer',
                  background: mode === m ? 'linear-gradient(135deg, rgba(0,200,255,0.15), rgba(0,100,220,0.2))' : 'transparent',
                  color: mode === m ? 'var(--cyan)' : 'var(--text2)',
                  border: mode === m ? '1px solid rgba(0,255,255,0.25)' : '1px solid transparent',
                  transition: 'all 0.15s'
                }}>
                  {m === 'login' ? 'Anmelden' : 'Registrieren'}
                </button>
              ))}
            </div>
          )}

          {mode === 'forgot' && (
            <div style={{ marginBottom: 20 }}>
              <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 4 }}>Passwort vergessen</h2>
              <p style={{ fontSize: 12, color: 'var(--text2)' }}>Wir schicken dir einen Link zum Zurücksetzen.</p>
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            {mode === 'register' && <Field label="NAME" value={name} onChange={setName} placeholder="Dein Name" />}
            <Field label="E-MAIL" type="email" value={email} onChange={setEmail} placeholder="name@beispiel.de" />
            {mode !== 'forgot' && <Field label="PASSWORT" type="password" value={password} onChange={setPassword} placeholder="Mindestens 8 Zeichen" />}
            {mode === 'login' && (
              <button type="button" onClick={() => { setMode('forgot'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: 'var(--text2)', fontSize: 11, textAlign: 'right', cursor: 'pointer', padding: 0, marginTop: -8 }}>
                Passwort vergessen?
              </button>
            )}
            {mode === 'register' && (
              <div>
                <Field label="INVITE-CODE" value={inviteCode} onChange={v => setInviteCode(v.toUpperCase())} placeholder="XXXX-XXXX" />
                <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 4 }}>Zugang nur mit Einladungscode.</p>
              </div>
            )}

            {mode === 'register' && (
              <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={dsgvoChecked}
                  onChange={e => setDsgvoChecked(e.target.checked)}
                  required
                  style={{ marginTop: 2, accentColor: 'var(--cyan)', width: 15, height: 15, flexShrink: 0, cursor: 'pointer' }}
                />
                <span style={{ fontSize: 12, color: 'var(--text2)', lineHeight: 1.5 }}>
                  Ich habe die{' '}
                  <a href="/datenschutz" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--cyan)', textDecoration: 'underline' }}>
                    Datenschutzerklärung
                  </a>
                  {' '}und die{' '}
                  <a href="/nutzungsbedingungen" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--cyan)', textDecoration: 'underline' }}>
                    Nutzungsbedingungen
                  </a>
                  {' '}gelesen und akzeptiere sie.
                </span>
              </label>
            )}

            {error && (
              <div style={{
                padding: '9px 13px', borderRadius: 8, fontSize: 12,
                ...(error.includes('abgelaufen')
                  ? { background: 'rgba(0,200,255,0.06)', border: '1px solid rgba(0,200,255,0.25)', color: 'var(--cyan)' }
                  : { background: 'rgba(255,0,85,0.08)',  border: '1px solid rgba(255,0,85,0.2)',   color: 'var(--red)'  })
              }}>{error}</div>
            )}

            {success && (
              <div style={{ padding: '9px 13px', borderRadius: 8, fontSize: 12, background: 'rgba(0,255,150,0.08)', border: '1px solid rgba(0,255,150,0.2)', color: 'var(--green)' }}>
                {success}
              </div>
            )}

            {!(mode === 'forgot' && success) && (
              <button type="submit" disabled={loading || (mode === 'register' && !dsgvoChecked)} className="btn-primary" style={{ marginTop: 4, padding: '12px', fontSize: 14, justifyContent: 'center', width: '100%' }}>
                {loading ? <><Spinner /> Verbinde...</> : mode === 'login' ? '▶ Anmelden' : mode === 'forgot' ? '▶ Link senden' : '▶ Konto erstellen'}
              </button>
            )}

            {mode === 'forgot' && (
              <button type="button" onClick={() => { setMode('login'); setError(''); setSuccess(''); }} style={{ background: 'none', border: 'none', color: 'var(--cyan)', fontSize: 12, cursor: 'pointer', padding: 0, textAlign: 'center' }}>
                ← Zurück zum Login
              </button>
            )}
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: 11, color: 'var(--muted)', marginTop: 18 }}>
          by <span style={{ color: 'var(--cyan)' }}>look4more</span> · Local SEO & Webdesign Neustrelitz
          {' '}·{' '}
          <a href="/datenschutz" style={{ color: 'var(--muted)', textDecoration: 'underline' }}>Datenschutz</a>
          {' '}·{' '}
          <a href="/nutzungsbedingungen" style={{ color: 'var(--muted)', textDecoration: 'underline' }}>Nutzungsbedingungen</a>
          {' '}·{' '}
          <a href="https://look4more.de/impressum" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--muted)', textDecoration: 'underline' }}>Impressum</a>
        </p>
      </div>
    </div>
  );
}

function Field({ label, type = 'text', value, onChange, placeholder }) {
  const [focused, setFocused] = React.useState(false);
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
      <span style={{ fontSize: 10, fontWeight: 600, fontFamily: 'Outfit', color: focused ? 'var(--cyan)' : 'var(--muted)', letterSpacing: '0.08em', transition: 'color 0.15s' }}>{label}</span>
      <input type={type} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)}
        onFocus={() => setFocused(true)} onBlur={() => setFocused(false)}
        required className="input" style={{ fontSize: 13 }}
      />
    </label>
  );
}

function Spinner() {
  return <span style={{ width: 12, height: 12, border: '2px solid rgba(0,255,255,0.2)', borderTopColor: 'var(--cyan)', borderRadius: '50%', animation: 'spin 0.7s linear infinite', display: 'inline-block' }} />;
}
